import hero from "./hero.jpg";

const obj = {
  hero,
};

export default obj;
